// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuItem_root__GW971","icon":"MenuItem_icon__7uWTk","active":"MenuItem_active__FhuGs","itemText":"MenuItem_itemText__G47BT"};